import {
  type ImageResult,
  manipulateAsync,
  SaveFormat,
} from 'expo-image-manipulator';
import * as ImagePicker from 'expo-image-picker';
import Toast from 'react-native-toast-message';

export default async function pickAvatar(): Promise<ImageResult | null> {
  let image: ImageResult | null = null;

  try {
    const res = await ImagePicker.launchImageLibraryAsync({
      base64: true,
      allowsEditing: true,
    });

    if (!res.canceled) {
      const croppedResult = await manipulateAsync(
        res.assets[0].uri,
        [{ resize: { width: 1024 } }],
        { format: SaveFormat.PNG },
      );

      image = croppedResult;
    }
  } catch {
    Toast.show({
      text1: 'Oh no!',
      text2: "Couldn't pick your avatar.  Please try again later.",
      type: 'error',
    });
  }

  return image;
}
